// Type for the Notification Type
export interface NotificationEntity {
  type: string;
  subType: string;
  data: any;
}

export interface GeneralSetting {
  id: number;
  name: string;
  uiText: string;
  settingsId: number;
  value: string;
}

export interface RowOrderSetting {
  isEnabled: boolean;
  isIncluded: boolean;
  sortOrder: number;
  fieldCode: string;
}

/**
 * Field Entity Type
 * Start
 */

export interface FieldCoreAttributes {
  id: number;
  name: string;
  code: string;
  order: number;
  multiLine: boolean;
  widthChange: number;
}

interface FieldUIAttributes {
  visible: boolean;
  pinned: boolean;
}

export interface UpdatedField {
  fieldCode: string;
  fieldValue: string;
}

export interface FieldUpdatePayload {
  code: string;
  name: string;
  order: number;
  isVisible: boolean;
  isPinned: boolean;
  widthChange: number;
}

export interface FieldEntity extends FieldCoreAttributes, FieldUIAttributes {}

//End

/**
 *  Tab/ Client Entity interface
 *  Start
 */
interface ClientCore {
  viewOrder: number;
  name: string;
}

export interface FilterCoreDTO extends ClientCore {
  externalId: string;
  deleted: boolean;
}

export interface ClientServerDTO extends ClientCore {
  externalId: string;
  custom: boolean;
  default: boolean;
  enabled: boolean;
  hashCode: string;
}

export interface ClientEntity extends ClientCore {
  id: string;
  custom: boolean;
  alias: ClientAlias[];
  default: boolean;
  enabled: boolean;
  hashCode: string;
}

export interface ClientAlias {
  id: string;
  name: string;
  custom: boolean;
  default: boolean;
  externalId: string;
  enabled: boolean;
  hashCode: string;
}
// End

/**
 * Market Entity Interface
 * start
 */
export interface MarketEntity {
  externalId: string;
  isCustom: boolean;
  name: string;
}
// End

/**
 * General Settings Interface
 * start
 */
export interface GeneralSettingsEntity {
  externalId: string;
  id: number;
  name: string;
  uiText: string;
  value: number;
}
// End

export interface AuthorEntity {
  externalId: string;
  name: string;
}
export interface DocumentFieldValuesEntity {
  field: string;
  value: string;
  prevValue: string;
  engineValue: string;
}

export interface DocumentFieldValuesForSidebarEntity
  extends DocumentFieldValuesEntity {
  reminderDate?: string;
}

export interface FilteredDocumentSettingsEntity {
  id: string;
  value: string;
  order: number;
  reminderDate: string;
  children?: FilteredDocumentSettingsEntity[];
}

export interface DocumentEntity {
  id: string;
  parent: string;
  name: string;
  status: string;
  notes: string;
  read: boolean;
  deleted: boolean;
  locked: boolean;
  expanded: boolean;
  ts: string;
  author: string;
  trade: string;
  market: string;
  client: string;
  rowsExpanded?: boolean;
  values: DocumentFieldValuesEntity[];
  grpOrder: Number;
  dashboardOrder: Number;
  order: Number;
  loiDate: string;
  reminderDate: string;
}

// Filter Entities

export interface FilterNavEntity {
  name: string;
  code: string;
  fieldCode: string;
}

export interface FilterEntity {
  id: string;
  name: string;
}

export interface FilterChoiceEntity {
  text: string;
  action: string;
  externalId?: string;
  isEditable?: boolean;
}

export interface pharseTextEntity {
  value: string;
  ts: string;
}

export interface phraseEntity {
  text: string;
  isSelected: boolean;
  index?: Number;
  externalId?: string;
  action?: string;
}

export interface FilterFieldChoiceEntity {
  fieldCode: string;
  fieldName?: string;
  has: FilterChoiceEntity[];
  hasNot: FilterChoiceEntity[];
  historyList?: phraseEntity[];
  selectedFields?: phraseEntity[];
}

export interface StateEntity {
  isSelected: boolean;
  text: string;
  code: string;
  externalId?: string;
}

export interface SideBarEntity {
  name: string;
  id: string;
  isFolder: boolean;
  children?: Set<string>;
}

export interface SideBarEntityOrdered {
  name: string;
  id: string;
  isFolder: boolean;
  children?: string[];
}

export interface SettingsMetadata {
  externalId: string;
  name: string;
  uiText: string;
  uiOrder: number;
}

export interface SettingsFilterViewMetadata {
  externalId: string;
  name: string;
  enabled: boolean;
  uiOrder: number;
}

export interface AutoFilterLevelSettingsMeta {
  uiOrder: Number;
  fieldName: string;
  filterType: string;
  filterText: string;
}

export interface AutoFilterSettings {
  filterViewexternalId: string;
  values: AutoFilterLevelSettingsMeta[];
}

export interface DefaultSettingsValue {
  subSettingsExternalId: string;
  uiOrder: number;
  name: string;
  value: string;
}

export interface DefaultSettings {
  settingsExternalId: string;
  settings: DefaultSettingsValue[];
}

export const nameMapping: Record<string, string> = {
  FIELD: "field_code",
  MINIMUM_LOI: "minimum_loi",
  TEXT: "text",
};

export interface SideBarDocMetadata {
  docId: string;
  parent: string;
  reminderDate: string;
}

export interface TreeDataEntity {
  treeEntityData: SideBarType[];
  treeMatchIdsToDocs: Record<string, Record<string, Set<string>>>;
}

export type SideBarType = Record<string, SideBarEntity>;

export type SideBarTypeOrdered = Record<string, SideBarEntityOrdered>;
